const _ = require('lodash'), authenticationHandler = require('./authentication-handler');

module.exports = function ($stateProvider) {
    $stateProvider
        .state('shop.myaccount', {
            resolve: {
                modules: ['$ocLazyLoad', $ocLazyLoad =>
                    $ocLazyLoad.load(['myaccount']),
                ],
                authMethod: ['ShopperService', shopperService =>
                    (shopperService.getAuthenticationMethod().then(response => response.AuthenticationMethod)),
                ],
            },
            url: '/myaccount',
            onEnter: [
                '$state', '$q', 'LoginService', 'authMethod',
                _.partialRight(authenticationHandler, 'Please reauthenticate before accessing My Account'),
            ],
            views: {
                'left-panel@shop': {
                    template: '<wow-my-account-nav-links></wow-my-account-nav-links>',
                },
                'rr-instrumentation-panel@root': {
                    template: '<wow-rr-mypage-instrumentation></wow-rr-mypage-instrumentation>',
                },
            },
            data: {
                authenticate: true,
                pageMetadata: {
                    title: 'Account Details',
                    metaDescription: 'Account Details',
                },
            },
        })
        .state('shop.myaccount.accessibility', {
            url: '/accessibility',
            views: {
                'center-panel@shop': {
                    template: '<wow-shopper-accessibility></wow-shopper-accessibility>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.preferences', {
            url: '/preferences',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-account-shopper-preferences></wow-my-account-shopper-preferences>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.deliveryaddresses', {
            url: '/deliveryaddresses',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-account-delivery-addresses></wow-my-account-delivery-addresses>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.changepassword', {
            url: '/password',
            views: {
                'center-panel@shop': {
                    controller: [
                        '$state', function ($state) {
                            $state.go('shop.myaccount.security');
                        },
                    ],
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.woolworthsrewards', {
            url: '/woolworthsrewards?{success:boolean}&{result:int}',
            views: {
                'center-panel@shop': {
                    template: '<wow-rewards></wow-rewards>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.trackmyorder', {
            url: '/trackmyorder?ordernumber',
            views: {
                'center-panel@shop': {
                    controller: [
                        '$stateParams', function ($stateParams) {
                            this.orderNumber = $stateParams.ordernumber;
                        },
                    ],
                    controllerAs: '$ctrl',
                    template: '<wow-my-account-track-my-order order-number="$ctrl.orderNumber"></wow-my-account-track-my-order>',
                },
                'left-panel@shop': {
                    template: '<wow-my-account-nav-links></wow-my-account-nav-links>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.security', {
            url: '/security',
            views: {
                'center-panel@shop': {
                    template: '<wow-security></wow-security>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.trackmyorder.orderId', {
            url: '/:orderId',
        })
        .state('shop.myaccount.details', {
            url: '/details',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-account-details></wow-my-account-details>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.deliverysavers', {
            url: '/deliverypasses',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-account-delivery-savers></wow-my-account-delivery-savers>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.deliveryunlimited', {
            url: '/deliveryunlimited',
            resolve: {
                modules: ['$ocLazyLoad', $ocLazyLoad =>
                    $ocLazyLoad.load(['deliverysaver']),
                ],
            },
            views: {
                'center-panel@shop': {
                    template: '<wow-my-delivery-saver></wow-my-delivery-saver>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.myorders', {
            url: '/myorders',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-orders></wow-my-orders>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.myinvoices', {
            url: '/myinvoices?{pageNumber:int}&{searchInvoice}&{startDate}&{endDate}',
            views: {
                'center-panel@shop': {
                    template: '<wow-my-invoices></wow-my-invoices>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.paymentmethods', {
            url: '/paymentmethods',
            views: {
                'center-panel@shop': {
                    template: '<wow-payment-methods></wow-payment-methods>',
                },
            },
            data: {
                authenticate: true,
            },
        })
        .state('shop.myaccount.transactionhistory', {
            url: '/transactionhistory',
            views: {
                'center-panel@shop': {
                    template: '<wow-transaction-history></wow-transaction-history>',
                },
            },
            data: {
                authenticate: true,
            },
        });
};



// WEBPACK FOOTER //
// ./src/configuration/routes/myaccount.js